import React, { Component } from 'react'
import { graphql } from 'react-apollo'

import PropTypes from 'prop-types'
import cn from 'classnames'
import get from 'lodash/get'
// import moment from 'moment'
import Form from '../Form'
// import 'react-datetime/css/react-datetime.css'

import ASK_QUESTION_MUTATION from '../../graphql/mutations/AskQuestionMutation.graphql'
import { getUser } from '../../utils'

const MODAL_ID = 'askQuestionModal'
const MODAL_LABEL_ID = 'askQuestionLabel'

class AskQuestion extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      // name: props.question.name,
      // title: props.question.title,
      // description: props.question.description,

        //  initialize nickname to the user's name
      nickName: getUser().slackRealName,
        // HACK: this should not be pulled into state here, it should be passed into a prop via a HOC. need to refactor it.
      user: getUser(),
        // name: '',
      title: '',
      description: '',
    }
  }

  handleQuestionSubmission = async () => {
      // alert(JSON.stringify(this.state))
      // console.log(this.props.board.uuid)
    await this.props.mutate({
      variables: {
        boardUuid: this.props.board.uuid,
        // name: this.props.name,
        // title: this.props.title,
        // description: this.props.description,
        // name: this.state.name,
        // title: this.state.title,
        // description: this.state.description,
          nickName: this.state.nickName,
          title: this.state.title,
          description: this.state.description,
          // slackUserId: this.state.user.slackId,
      },
    })
  }

  handleOpenModal = () => {
    this.setState({
      showModal: true,
      // date: this.props.board.submissionEndDate,
      nickName: getUser().slackRealName,
      title: '',
      description: '',

    })
  }

  handleCloseModal = () => {
      // console.log(this.props.onCloseRefreshHandler)
      // this.props.onCloseRefreshHandler({variables: { fetchPolicy: 'cache-and-network' }})

      setTimeout(() => {
          this.props.onCloseRefreshHandler()
      }, 1000);

      this.setState({
      showModal: false,
      })
      // this.props.onCloseRefreshHandler()
  }

  handleBackdropClick = e => {
    if (get(e, 'target.id') === MODAL_ID) {
      this.handleCloseModal()
    }
  }

    handleTitleChange(event) {
        this.setState({title: event.target.value})
    }

    handleNickNameChange(event) {
        this.setState({nickName: event.target.value})
    }

    handleDescriptionChange(event) {
        this.setState({description: event.target.value})
    }

  componentDidUpdate() {
    document.body.classList.toggle('modal-open', this.state.showModal)
  }

    handleSubmitAndCloseModal = () => {
        var val = this.handleQuestionSubmission();
        console.log("handleSubmitAndCloseModal:" + val);
        var val2 = this.handleCloseModal();
        return val;
    }


    render() {
    const { showModal } = this.state
    const { board } = this.props

    if (board.isArchived) {
      return null
    }

    return (
      <div className="col-sm-6 col-md-3 col-lg-2 pb-2">
          {/*&nbsp;&nbsp;*/}
        <button className="btn btn-primary btn-block" onClick={this.handleOpenModal}>
          <i className="fa fa-microphone" /><span className="ml-2">Ask Question</span>
        </button>
          {/*&nbsp;&nbsp;*/}
        <div
          className={cn('modal fade', { show: showModal })}
          id={MODAL_ID}
          tabIndex="-1"
          role="dialog"
          aria-labelledby={MODAL_LABEL_ID}
          aria-hidden="true"
          style={{ display: showModal ? 'block' : 'none' }}
          onClick={this.handleBackdropClick}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header jelly-background-color">
                <h5 className="modal-title" id={MODAL_LABEL_ID}>
                    <strong>Ask Question</strong>
                </h5>
                <button onClick={this.handleCloseModal} className="close" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

                <Form onValidateHandler={this.handleSubmitAndCloseModal}>
                  <div className="modal-body">
                      {this.props.board.allowAnonymous && (
                          <div className="form-group">
                              <div className="controls">
                                  {/*<label htmlFor="nickName" className=""><strong>Name</strong><span className="text-muted"> (Optional)</span></label>*/}
                                  {/*<input id="nickName" placeholder="" type="text" className="form-control" value={this.state.nickName} onChange={this.handleNickNameChange.bind(this)}></input>*/}
                                  {/*<small className="help-block form-text text-muted">Use your name, a nickname, or leave blank to be anonymous</small>*/}
                                  <label htmlFor="nickName" className=""><strong>Name</strong><span className="text-muted"> (Optional)</span></label>
                                  <select className="form-control" id="nickName" onChange={this.handleNickNameChange.bind(this)} value={this.state.nickName}>
                                    <option value={this.state.user.slackRealName}>{this.state.user.slackRealName}</option>
                                    <option value="">Anonymous</option>
                                     </select>
                                  <small className="help-block form-text text-muted">Use your name, or select anonymous</small>
                              </div>
                          </div>
                      )}
                      <div className="form-group">
                          <label htmlFor="title" className=""><strong>Question</strong></label>
                          <input id="title" placeholder="" required="true" type="text" className="form-control" value={this.state.title} onChange={this.handleTitleChange.bind(this)}></input>
                          <div className="invalid-feedback">Question is required!</div>
                      </div>
                      <div className="form-group">
                          <label htmlFor="description" className=""><strong>Description</strong><span className="text-muted"> (Optional)</span></label>
                          <textarea name="description" id="description" placeholder="" type="textarea" className="form-control" rows="3" value={this.state.description} onChange={this.handleDescriptionChange.bind(this)}></textarea>
                      </div>
                      {/*<div className="form-group">*/}
                          {/*<label className="text-muted"><i className="fa fa-info-circle" /> To ask a question in Slack: <span className="jelly-color-danger jelly-background-color">/jellyfish question</span></label>*/}
                      {/*</div>*/}
                  </div>
                  <div className="modal-footer">
                      {/*<div className="form-group">*/}
                      <div className="">
                          <button className="btn btn-secondary" type="button" onClick={this.handleCloseModal}>Cancel</button>
                          <span className="mx-2"></span>
                          <button className="btn btn-primary" type="submit">Ask</button>
                      </div>
                  </div>
                </Form>

            </div>
          </div>
        </div>
        {showModal && <div className="modal-backdrop fade show" />}
      </div>
    )
  }
}

AskQuestion.propTypes = {
  // title: PropTypes.string,
  // description: PropTypes.string,
  // name: PropTypes.string,
  board: PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      allowAnonymous: PropTypes.bool.isRequired
  }),
    onCloseRefreshHandler: PropTypes.func.isRequired,
}

export default graphql(ASK_QUESTION_MUTATION)(AskQuestion)



// WEBPACK FOOTER //
// ./src/components/Board/AskQuestion.jsx